import { useState, type ReactNode } from 'react';
import type { UserDto } from '../api';
import { AuthContext } from './context';
import {
  clearStoredTokens,
  getStoredTokens,
  setStoredTokens,
  type StoredTokens,
} from './tokenStorage';

interface AuthState {
  tokens: StoredTokens | null;
  user: UserDto | null;
}

export function AuthProvider({ children }: { children: ReactNode }) {
  const [state, setState] = useState<AuthState>(() => ({
    tokens: getStoredTokens(),
    user: null,
  }));

  const authenticate = (tokens: StoredTokens, user: UserDto | null) => {
    setStoredTokens(tokens);
    setState({ tokens, user });
  };

  const logout = () => {
    clearStoredTokens();
    setState({ tokens: null, user: null });
  };

  return (
    <AuthContext.Provider value={{ ...state, authenticate, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
